module.exports = __webpack_public_path__ + "static/041-67551021efb49bc32b89ae530380382f.jpg";